import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import utility from "@/shared/utility";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import receiveSrvice from "./receive-srvice";
import commonApiService from "@/components/common/js/common-api-service";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      showSOPOButton: false,
      showProjectDetailsDialog: false,
      showStockRoom: false,
      validateType: "",
      wareId: "",
      focusField: "",
      stockroomInfo: false,
      includeClosed: false,
      showOk: false,
      disableStagingLoc: false,
      projectDetailsObj: {
        proj_id: "",
        staging_loc: "",
        lpn: "",
      },
      dialogTitle: "",
      projectList: [],
      stockroomList: [],
      stockroomText: "",
      stockroomReq: false,
      showStackInfo: false,
      sessionId: "",
      searchLPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
      required: [(v) => !!v || "Field is required"],
    };
  },
  async created() {
    this.route = this.$route.path?.replace("/", "")?.split("/")[0];
    this.receiveType = this.$route.path?.replace("/", "")?.split("/")[1];
    if (this.receiveType) {
      this.onClickParamterType(this.receiveType);
    }
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    const { soObj, poObj } = this.actionList.reduce(
      (acc, item) => {
        if (item.SystemName === "SOReceiving") acc.soObj = item;
        if (item.SystemName === "POReceiving") acc.poObj = item;
        return acc;
      },
      { soObj: null, poObj: null }
    );
    if (soObj && !poObj) {
      this.onClickSalesOrder();
    } else if (poObj && !soObj) {
      this.onClickPurchase();
    }
    this.debouncedStockroomList = utility.debounce(this.getStockroomList, 500);
  },
  computed: {
    formattedWarehouses() {
      return this.stockroomList?.map((warehouse) => ({
        ...warehouse,
        ware: this.formatShowroom(warehouse.ware), // Format the warehouse data
      }));
    },
  },
  async mounted() {
    this.showSOPOButton = true;
  },
  methods: {
    //Show LPN Data on breadcrumb

    //To add and remove From Fav
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    actionSetter(permission) {
      return utility.actionSetter(this.actionList, permission);
    },
    //on click of SO/PO
    async onClickParamterType(type) {
      this.validateType = type;
      this.showSOPOButton = false;
      this.showProjectDetailsDialog = true;
      this.dialogTitle = type === "SO" ? "Set SO Parameters" : "Set PO Parameters";
      let projectData = await receiveSrvice.getReceiveProject("get", this.userId, type === "SO" ? "S" : "P");
      this.projectList = projectData.Result.LineInfo;
      this.sessionId = projectData.Result.SessionInfo[0].Session;
      if (this.receiveType) {
        let lpnObj = JSON.parse(EncryptUtility.localStorageDecrypt("receivelpnDetails"));
        let projectDetails = this.projectList.filter((x) => x.project_id == lpnObj.proj_key)[0];
        this.projectDetailsObj.proj_id = projectDetails;
        this.showLPN = true;
      }
    },
    //Close project Details
    closeDialog() {
      this.showProjectDetailsDialog = false;
      this.disableStagingLoc = false;
      this.showSOPOButton = true;
      this.receiveType = "";
      this.showOk = false;
      this.dialogTitle = "";
      this.validateType = "";
      this.projectList = [];
      this.projectDetailsObj = {
        proj_id: "",
        staging_loc: "",
        lpn: "",
      };
      this.$refs?.projectForm?.resetValidation();
      this.clearLPN();
    },
    clearLPN() {
      this.stockroomText = "";
      this.stockroomInfo = "";
      this.showLPN = false;
      this.$refs?.lpnForm?.resetValidation();
      this.disableStagingLoc = false;
      this.projectDetailsObj.lpn = "";
      this.projectDetailsObj.staging_loc = "";
    },
    //on Change project
    onChangeProject() {
      if (this.receiveType || this.$refs?.projectForm?.validate()) {
        this.clearLPN();
        this.showLPN = this.projectDetailsObj?.proj_id?.lpn_active;
        this.showOk = !this.projectDetailsObj?.proj_id?.lpn_active;
        if (this.projectDetailsObj?.proj_id?.project_id == 72 && (this.receiveType == "SO" || this.validateType == "SO")) {
          this.showLPN = false;
          this.focusField = "Stockroom";
        } else {
          this.focusField = "Staging";
        }
      }
    },
    async onClickValidate() {
      // Validate projectForm and optionally validate lpnForm based on showLPN flag
      const isProjectFormValid = this.$refs?.projectForm?.validate();
      const isLPNFormValid =
        this.showLPN && this.projectDetailsObj?.proj_id?.project_id !== 72 && (this.validateType == "SO" || this.receiveType == "SO")
          ? this.$refs?.lpnForm?.validate()
          : true;
      if (isProjectFormValid && isLPNFormValid) {
        let lpnObj = {
          UserId: this.userId,
          bin: this.projectDetailsObj?.staging_loc,
          lpn: this.projectDetailsObj?.lpn,
          proj_key: this.projectDetailsObj?.proj_id?.project_id,
        };
        let res = await receiveSrvice.postValidateLPNStage("post", lpnObj, false);
        if (res?.[0]?.stage_bin_key) {
          lpnObj.wareId = this.wareId;
          lpnObj.stage_bin_key = res?.[0]?.stage_bin_key;
          this.projectDetailsObj?.proj_id?.project_id == 72 && (this.validateType == "SO" || this.receiveType == "SO")
            ? this.redirectToPage(lpnObj, "US")
            : this.redirectToPage(lpnObj);
        }
      }
    },
    redirectToPage(lpnObj, pageType) {
      lpnObj.projectName = this.projectDetailsObj?.proj_id?.project;
      lpnObj.sessionId = this.sessionId;
      lpnObj.stockRoom = this.stockroomText;
      lpnObj.warehouseDetails = this.stockroomInfo;
      EncryptUtility.localStorageEncrypt("receivelpnDetails", JSON.stringify(lpnObj));
      pageType == "US" ? this.$router.push(`/receiving-list-usbank/${this.validateType}`) : this.$router.push(`/receiving-list/${this.validateType}`);
    },
    onClickOk() {
      let lpnObj = {
        UserId: this.userId,
        bin: this.projectDetailsObj?.staging_loc,
        lpn: this.projectDetailsObj?.lpn,
        proj_key: this.projectDetailsObj?.proj_id?.project_id,
      };
      this.redirectToPage(lpnObj);
    },
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN("get", this.userId);
      if (lpnData.message !== "NA") {
        this.projectDetailsObj.lpn = lpnData[0]?.lpn;
      }
    },
    lpnNumFormat(event, num) {
      this.projectDetailsObj.lpn = utility.formatLPNNumber(event, num);
    },
    getStockroomData() {
      if (this.stockroomText?.length > 2) {
        this.showStackroomDDL = true;
        this.debouncedStockroomList();
      } else {
        this.showStackroomDDL = false;
      }
    },
    async getStockroomList() {
      this.stockroomList = await receiveSrvice.getStockroomList("get", this.userId, this.stockroomText, false);
    },
    async showStockItem(item) {
      item.ware_id !== 643 ? await this.getLPNNumber() : "";
      this.showStackroomDDL = false;
      this.showStackInfo = true;
      this.stockroomInfo = this.formatShowroom(item.ware);
      item.ware_id == 643 ? (this.disableStagingLoc = false) : (this.disableStagingLoc = true);
      const match = item.ware.match(/<b>(.*?)<\/b>/);
      this.stockroomText = match[1];
      this.projectDetailsObj.staging_loc = item.ware_id == 643 ? "" : `USB-${this.stockroomText}`;
      this.showLPN = true;
      this.wareId = item.ware_id;
      item.ware_id != 643 ? this.onClickValidate() : "";
    },
    clearStockroom(){
      this.showStackroomDDL = false;
      this.showStackInfo = false;
      this.stockroomInfo = "";
      this.showLPN = false;
      this.stockroomText = "";
      this.projectDetailsObj.staging_loc = "";
      this.wareId = "";
    },
    formatShowroom(ware) {
      if (!ware) return ""; // Handle empty or undefined input
      const parts = ware?.split("||"); // Split by '||'
      if (parts.length < 2) return ware; // Edge case: if there are fewer than two parts, return as-is
      // Format the first two values in bold and join with <br/>
      return `<b>${parts[0]}</b><br/><b>${parts[1]}</b><br/>` + parts.slice(2).join("<br/>");
    },
    onClickReceiveLPNFunction() {
      this.showLPNChange = true;
    },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
  },
};
